import React, { useState, useCallback, useEffect, useRef } from 'react';
import { orgTypes } from '../../Constants';
import useApi from '../../api/useApi';

function CreateRule({ handleClose, notification, action, selectedrule, refreshList }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    ruleName: '',
    scope: '',
    item: '',
    parameter: '',
    value: '',
    condition: '',
    recipients: null,
    priority: '',
    organizationId: orgId,
    createdBy: userId,
    isActive: true,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [updateData, postUpdateData] = useApi();
  const [getRule, getDataForUpdate] = useApi();
  const [getProject, setProject] = useApi();
  const [getDevice, setDevice] = useApi();
  const [attributes, setAttributes] = useState([]);

  const sms = useRef(null);
  useEffect(() => {
    setProject(`/organization/${orgId}/projects`, 'GET');
    setDevice(`/organization/${orgId}/devices`, 'GET');
  }, []);
  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/rule/${selectedrule}`, 'GET');
    }
  }, [action]);

  useEffect(() => {
    if (!getRule.isLoading && !getRule.isError && getRule.data) {
      setFormData(getRule.data.message);
      setAttributes(getRule.data.message.recipients);
    }
  }, [getRule]);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleSubmit = (e) => {
    e.preventDefault();
    if (attributes.length === 0) {
      attributes.push(sms.current.value);
    }
    formData.recipients = attributes.length > 0 ? attributes : null;
    if (action === 'create') postData(`/rule`, 'POST', formData);
    else postUpdateData(`/rule/${selectedrule}`, 'PATCH', formData);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      // setFormData({ ...formModel });
      notification('success', 'Rule created successfully');
      refreshList();
      handleClose();
    }

    if (isError) {
      notification('error', data);
      // handleClose();
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!updateData.isLoading && !updateData.isError && updateData.data) {
      // setFormData({ ...formModel });
      notification('success', 'Rule updated successfully');
      refreshList();
      handleClose();
    }

    if (isError) {
      notification('error', updateData.data);
      // handleClose();
    }
  }, [updateData]);

  const handleAddAttributes = (e) => {
    e.preventDefault();
    const k = sms.current.value;
    if (!ValidateEmail(k)) {
      notification('error', `Enter valid emailId`);
      sms.current.value = '';
      return;
    }
    const x = attributes;
    setAttributes([...x, k]);
    sms.current.value = '';
  };

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }

  const deleteAttribute = (item) => {
    const filterAttributes = attributes.filter((x) => x !== item);

    setAttributes(filterAttributes);
  };

  useEffect(() => {
    sms.current.value = '';
  }, [attributes]);

  useEffect(() => {}, [attributes]);
  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-2/4 px-5 pt-1 relative top-${action === 'create' ? 0 : 8} rounded-2xl mobile_toggle`}>
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-4 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">{action === 'create' ? 'New' : 'Edit'} Rule</p>

        <form className="mt-6 mb-2 mx-10" autoComplete="new-password" onSubmit={handleSubmit}>
          <div className="flex flex-wrap">
            <div className="mt-4 w-2.25/5 relative">
              <input
                type="text"
                placeholder="Rule Name"
                value={formData.ruleName}
                name="ruleName"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange}
              />
            </div>
            <div className="mt-4 w-2.25/5 relative" />
            {/* <div className="w-1/10" /> */}
            <div className="mt-4 w-2.25/5 relative">
              <div className="inputLabelText px-4 py-2 focus:outline-none">
                <select
                  name="scope"
                  value={formData.scope}
                  className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                  onChange={handleInputChange}
                  style={{ color: '#b3b3b3' }}
                >
                  <option className="fy-4">Select Global/Project/Device</option>
                  <option key="global" value="global" className="fy-4">
                    Global
                  </option>
                  <option key="project" value="project" className="fy-4">
                    Project
                  </option>
                  <option key="device" value="device" className="fy-4">
                    Device
                  </option>
                </select>
              </div>
            </div>
            <div className="mt-4 w-2.25/5 relative" />
            <div className="mt-4 w-2.25/5 relative">
              {formData.scope === 'global' && (
                <div className="inputLabelText px-4 py-2 focus:outline-none">
                  <input
                    className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                    onChange={handleInputChange}
                    placeholder="Select Global"
                    value="Select Global"
                    disabled
                  />
                </div>
              )}

              {formData.scope === 'project' && (
                <div className="inputLabelText px-4 py-2 focus:outline-none">
                  <select
                    name="item"
                    value={formData.item}
                    className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                    onChange={handleInputChange}
                    style={{ color: '#b3b3b3' }}
                  >
                    <option key="project" value="project" className="fy-4">
                      Select Project
                    </option>
                    {getProject.data !== null &&
                      getProject.data.projects.map((x, id) => (
                        <option key={id} value={x?.id} className="fy-4">
                          {x?.projectName}
                        </option>
                      ))}
                    {/* <option key="project" value="project" className="fy-4">
                      Project1
                    </option>
                    <option key="device" value="device" className="fy-4">
                      Project2
                    </option> */}
                  </select>
                </div>
              )}
              {formData.scope === 'device' && (
                <div className="inputLabelText px-4 py-2 focus:outline-none">
                  <select
                    name="item"
                    value={formData.item}
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                    style={{ color: '#b3b3b3' }}
                  >
                    <option key="project" value="project" className="fy-4">
                      Select Device
                    </option>
                    {getDevice.data !== null &&
                      getDevice.data.devices.map((x, id) => {
                        if (x.deviceType !== 'BLE_GW' && x.deviceType !== 'PHONE_GW') {
                          return (
                            <option key={id} value={x?.id} className="fy-4">
                              {x?.id}
                            </option>
                          );
                        }
                      })}
                  </select>
                </div>
              )}
            </div>
          </div>

          <p className="pt-4">Conditions</p>
          <div className="flex flex-wrap">
            <div className="mt-4 w-2.25/5 relative">
              <div className="inputLabelText px-4 py-2 focus:outline-none">
                <select
                  name="parameter"
                  value={formData.parameter}
                  className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                  onChange={handleInputChange}
                  style={{ color: '#b3b3b3' }}
                >
                  <option className="fy-4">Alert type</option>
                  <option key="temperature" value="temperature" className="fy-4">
                    Temperature
                  </option>
                  <option key="pressure" value="pressure" className="fy-4">
                    Pressure
                  </option>
                  <option key="humidity" value="humidity" className="fy-4">
                    Humidity
                  </option>
                  <option key="tor" value="tor" className="fy-4">
                    ToR
                  </option>
                  <option key="vbat" value="vbat" className="fy-4">
                    Battery
                  </option>
                  <option key="rssi" value="rssi" className="fy-4">
                    RSSI
                  </option>
                </select>
              </div>
            </div>
            <div className="w-1/10" />
            <div className="mt-4 w-2.25/5 relative">
              <div className="inputLabelText px-4 py-2 focus:outline-none">
                <select
                  name="condition"
                  value={formData.condition}
                  className="border-none w-full focus:outline-none text-sm font-normal text-parameter border "
                  onChange={handleInputChange}
                  style={{ color: '#b3b3b3' }}
                >
                  <option className="fy-4">Conditions</option>
                  <option key="isEqualTo" value="===" className="fy-4">
                    IsEqualTo
                  </option>
                  <option key="isNotEqualTo" value="!==" className="fy-4">
                    IsNotEqualTo
                  </option>
                  <option key="isLessThan" value="<" className="fy-4">
                    IsLessThan
                  </option>
                  <option key="isGreaterThan" value=">" className="fy-4">
                    IsGreaterThan
                  </option>
                  <option key="isGreaterThanEqualTo" value=">=" className="fy-4">
                    IsGreaterThanEqualTo
                  </option>
                  <option key="isLessThanEqualTo" value="<=" className="fy-4">
                    IsLessThanEqualTo
                  </option>
                </select>
              </div>
            </div>
            <div className="mt-4 w-2.25/5 relative">
              <input
                type="number"
                placeholder="Value"
                value={formData.value}
                autoComplete="off"
                name="value"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange}
                // style={{ color: '#b3b3b3' }}
                // onChange={handleSourceAddressChange}
              />
            </div>
            <div className="w-1/10" />
            <div className="mt-4 w-2.25/5 relative">
              <input
                type="email"
                placeholder="Email of Receipient"
                ref={sms}
                autoComplete="off"
                className="inputLabelText px-4 py-2 focus:outline-none"
                // style={{ color: '#b3b3b3' }}
                onChange={handleInputChange}
                onKeyDown={(e) => {
                  // e.preventDefault()
                  if (e.keyCode === 13) {
                    handleAddAttributes(e);
                  }
                }}
              />
            </div>
            <div className="w-full flex mt-4 h-6 text-center">
              {attributes &&
                attributes.map((item) => (
                  <p
                    className="text-black text-xs h-6 px-4 text-center rounded-full border mx-2 cursor-pointer"
                    onClick={() => deleteAttribute(item)}
                  >
                    {item}
                  </p>
                ))}
            </div>
            {/* <div className="w-1/10" /> */}
            {/* <div className="w-2.25/5 mt-4">
              <input
                type="text"
                placeholder="Send Notification"
                value={formData.notification}
                autoComplete="off"
                name="Notification"
                className="inputLabelText px-4 py-2 focus:outline-none"
                // onChange={handleSourceAddressChange}
              />
            </div> */}
            <div className="w-7/12" />

            <div className="w-5/12 relative -right-8 mb-2 mt-4">
              {isLoading ? (
                <div className="flex text-xs">
                  <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
                </div>
              ) : (
                <div className="flex text-xs">
                  <button
                    type="submit"
                    onClick={() => handleClose()}
                    className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                    // style={{ border: '1px solid #16406D' }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-3xl focus:outline-none w-1/2 h-10 text-white cursor-pointer "
                    style={{ background: '#16406D' }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateRule;
